import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    user: String,
    domain: String
  }

  open(event) {
    event.preventDefault()
    const email = this.userValue + '@' + this.domainValue
    window.location.href = 'mailto:' + email
  }
}
